import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { eiwrsCorierManagementServices } from "../../../../../APIServices/EIWRS/ShipmentManagement/eiwrsCorierManagementServices";

const UpdateCorier = ({
  rowData,
  corierColumns,
  getStudyCorierRowData,
  Show,
  Hide,
  Title,
  setRowId,
  countryList,
  stateList,
  cityList,
  setCountryId,
  setStateId
}) => {
  const [corierRow, setCorierRow] = useState({});
  const handleCorierRowChange = (e, columnKey) => {
    setCorierRow({
      ...corierRow,
      [columnKey]: e.target.value,
    });
  };
  let { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateStudyCorierRowData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Corier!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = rowData?._id;
        userData.studyId = studyId;
        userData.corierRow = corierRow;
        let data =
          await eiwrsCorierManagementServices.updateStudyCorierRowData(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyCorierRowData();
          setRowId("");
          Hide();
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setCorierRow(rowData?.row);
  }, [rowData]);

  function isRowDataComplete() {
    return corierColumns.every((col) => {
      const key = col.columnName;
      return (
        corierRow?.hasOwnProperty(key) &&
        corierRow?.[key] !== "" &&
        corierRow?.[key] !== null &&
        corierRow?.[key] !== undefined
      );
    });
  }
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {corierColumns?.map((item, index) => (
            <Form.Group key={index} className="mb-1">
              <Form.Label className="fw-bold mb-1">
                {item?.columnLabel}{" "}
                {item?.required === "yes" &&
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                }
              </Form.Label>
              {item?.columnType === "dropdown" ? (
                <>
                  {item?.customOption === "yes" ?
                    <>
                      {item?.columnName === "COUNTRY" ?
                        <Form.Select
                          value={corierRow?.[item?.columnName]}
                          onChange={(e) => { handleCorierRowChange(e, item?.columnName); setCountryId(e.target[e.target.selectedIndex].title) }}
                          className="br3" style={{ fontSize: 12 }}>
                          <option value="">Select Country</option>
                          {countryList?.map((el, i) => (
                            <option index={i} value={el?.name} title={el.id}>{el?.name}</option>
                          ))}
                        </Form.Select>
                        : item?.columnName === "STATE" ?
                          <Form.Select
                            value={corierRow?.[item?.columnName]}
                            disabled={stateList?.length === 0}
                            onChange={(e) => { handleCorierRowChange(e, item?.columnName); setStateId(e.target[e.target.selectedIndex].title) }}
                            className="br3" style={{ fontSize: 12 }}>
                            <option value="">Select State</option>
                            {stateList?.map((el, i) => (
                              <option index={i} value={el?.name} title={el.id}>{el?.name}</option>
                            ))}
                          </Form.Select>
                          : item?.columnName === "CITY" &&
                          <Form.Select
                            value={corierRow?.[item?.columnName]}
                            disabled={cityList?.length === 0}
                            onChange={(e) => handleCorierRowChange(e, item?.columnName)}
                            className="br3" style={{ fontSize: 12 }}>
                            <option value="">Select City</option>
                            {cityList?.map((el, i) => (
                              <option index={i} value={el?.name}>{el?.name}</option>
                            ))}
                          </Form.Select>
                      }
                    </>
                    :
                    <Form.Select
                      onChange={(e) => handleCorierRowChange(e, item?.columnName)}
                      className="br3"
                      style={{ fontSize: 12 }}
                    >
                      <option value="">Select Option</option>
                      {(item?.columnOption || [])?.map((el, i) => (
                        <option
                          index={i}
                          selected={corierRow?.[item?.columnName] === el?.option}
                          value={el?.option}
                        >
                          {el?.option}
                        </option>
                      ))}
                    </Form.Select>
                  }
                </>
              ) : item?.columnType === "radio" ? (
                (item?.columnOption || [])?.map((el, i) => (
                  <Form.Check
                    key={i}
                    type="radio"
                    label={el?.option}
                    name={item?.columnName}
                    value={el?.option}
                    checked={corierRow?.[item?.columnName] === el?.option}
                    onChange={(e) =>
                      handleCorierRowChange(e, item?.columnName)
                    }
                    className="br3"
                  />
                ))
              ) : (
                item?.columnType === "textarea" ?
                  <Form.Control
                    onChange={(e) => handleCorierRowChange(e, item?.columnName)}
                    value={corierRow?.[item?.columnName] || ""}
                    className="br3"
                    placeholder={`Enter ${item?.columnLabel}`}
                    as={item?.columnType}
                  />
                  :
                  <Form.Control
                    onChange={(e) => handleCorierRowChange(e, item?.columnName)}
                    value={corierRow?.[item?.columnName] || ""}
                    className="br3"
                    placeholder={`Enter ${item?.columnLabel}`}
                    type={item?.columnType}
                  />
              )}
            </Form.Group>
          ))}
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!isRowDataComplete() || buttonLoader}
            onClick={updateStudyCorierRowData}
            className={`updateProfile`}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update corier"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateCorier;
